import type { TranslationTree } from '../../types';

export const layout: TranslationTree = {
  header: {
    menuToggle: 'Navigationsmenü öffnen',
    settingsTooltip: 'Einstellungen',
  },
  sidebar: {
    traceability: 'Werkzeugansicht',
    analytics: 'Analytik',
    ml: 'Maschinelles Lernen',
    labelize: 'Beschriftung',
    admin: 'Administration',
    backendConfig: 'Backend-Konfig',
    toolRecommender: 'Werkzeug-Ökodesign',
    workshop: 'Werkstatt',
    profile: 'Profil',
    collapse: 'Einklappen',
    expand: 'Ausklappen',
    disconnect: 'Abmelden',
    mobileNavigation: 'Mobile Navigation',
    desktopNavigation: 'Desktop-Navigation',
  },
  quickAccess: {
    traceability: 'Rückverfolgbarkeit',
  },
  avatarMenu: {
    language: 'Sprache',
    profile: 'Profil',
    logout: 'Abmelden',
    ariaLabel: 'Benutzermenü',
  },
  footer: {
    exploreLink: 'Louis Bélet entdecken',
    contactSupport: 'Support kontaktieren',
    rights: 'Alle Rechte vorbehalten.',
  },
};
